import React from "react";
import Layout from "../components/Layout";
import DataTable from "../components/DataTable";

const dt = (v) => (v ? new Date(v).toLocaleString("ko-KR") : "");

const team = (v) => {
  if (v === 1) return <span className="cell-tag green">GREEN</span>;
  if (v === 0) return <span className="cell-tag red">RED</span>;
  return "-";
};

const online = (v) =>
  v ? <span className="cell-tag on">ONLINE</span>
    : <span className="cell-tag off">OFF</span>;

export default function Participants() {
  return (
    <Layout title="참가자 Session Participants">
      <DataTable
        title="Session Participants"
        listPath="/api/admin/participants"
        summaryPath="/api/admin/summary/participants"
        defaultSort={{ key: "last_connected_at", order: "desc" }}
        columns={[
          { key: "id", label: "ID", sortable: true },
          { key: "session_uuid", label: "session_uuid", sortable: false },
          { key: "session_status", label: "세션 상태", sortable: false },
          { key: "nickname", label: "닉네임", sortable: false },
          { key: "client_index", label: "TD idx", sortable: true },
          { key: "team", label: "팀", sortable: true, render: team },
          { key: "current_score", label: "점수", sortable: true },
          { key: "max_combo", label: "콤보", sortable: true },
          { key: "rank", label: "순위", sortable: true },
          { key: "profile_image_index", label: "프로필 #", sortable: false },
          { key: "is_online", label: "접속", sortable: true, render: online },
          { key: "last_connected_at", label: "최근 접속", sortable: true, render: dt },
        ]}
      />
    </Layout>
  );
}
